import React from 'react';
import { Popover } from 'antd';
import { PopoverProps } from 'antd/lib/popover';
import getPopupContainer from '../../Hooks/getPopupContainer';

export type { PopoverProps };

const ProPopover: React.FC<PopoverProps> = React.forwardRef<any, PopoverProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Popover ref={ref} getPopupContainer={getPopupContainer} {...resProps}>
        {children}
      </Popover>
    );
  },
);

export default ProPopover;
